/*
 * YourXI formats picker (Bespoke XI wizard module)
 * --------------------------------------------------------------------------
 * Format + formation + pitch style picker. Needs kit-styles/pitches.js
 * (window.YourXIPitches) loaded first, and modules/formats.css on the page.
 * No other dependencies. CSS prefix: yxf-
 *
 *   const picker = YXIFormats.mount(containerEl, {
 *     formatId: 'eleven',          // any FORMATS id, or the aliases '11' '9' '7' '6' '5'
 *     formationId: '4-4-2',
 *     styleId: 'classic',          // classic | night | grass | clubTint | chalkboard
 *     tintColour: '#7A263A',       // used when styleId is clubTint
 *     onChange(sel, prev) { ... }  // sel = {formatId, formationId, styleId, tintColour}
 *   });                            // prev = the selection before this change
 *   picker.update({formationId: '4-3-3'});  // set from outside, does not fire onChange
 *   picker.get();                  // current selection
 *   picker.destroy();
 *
 *   YXIFormats.remapPlayers(oldSlots, newSlots, players, {subs, maxSubs})
 *     -> {players, subs, moved, removed, message}
 *   Keeps players when the format or formation changes. Slots are formation
 *   slots ({x, y, role, fine}) from getFormation(..).slots or layoutSlots(..),
 *   both lists in the same units. players[i] sits in oldSlots[i] (null = empty).
 *   GK stays GK, then players match by fine role (CB, W, ST...), then by
 *   coarse role (DF, MF, FW), then by nearest position. Anyone without a place
 *   goes to an empty sub spot (up to maxSubs), the rest come back in `removed`.
 *   message is ready for a toast, e.g. "2 players moved to subs", or "".
 */
(function (root) {
  'use strict';

  var FORMAT_LABELS = {
    eleven: '11-a-side', nine: '9-a-side', seven: '7-a-side', six: '6-a-side',
    five: '5-a-side', futsal: 'Futsal', walking5: 'Walking 5', walking6: 'Walking 6'
  };
  var STYLE_ORDER = ['classic', 'night', 'grass', 'clubTint', 'chalkboard'];
  var TINTS = [
    ['#C8102E', 'Red'], ['#7A263A', 'Claret'], ['#1C2C5B', 'Navy'], ['#1F3A93', 'Royal blue'],
    ['#6CABDD', 'Sky blue'], ['#00843D', 'Green'], ['#FDB913', 'Amber'], ['#F36C21', 'Orange'],
    ['#5B2C83', 'Purple'], ['#111111', 'Black']
  ];
  var DEFAULT_TINT = '#7A263A';

  function X() {
    var p = root.YourXIPitches;
    if (!p) throw new Error('YXIFormats needs kit-styles/pitches.js loaded first');
    return p;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function f1(n) { return Math.round(n * 10) / 10; }
  function normHex(h) {
    h = String(h || '').trim().replace('#', '');
    if (/^[0-9a-f]{3}$/i.test(h)) h = h.split('').map(function (c) { return c + c; }).join('');
    return /^[0-9a-f]{6}$/i.test(h) ? '#' + h.toUpperCase() : null;
  }

  /* ---------- small drawings ---------- */

  // line-only pitch icon for the format control, stroke follows currentColor
  function formatIcon(formatId) {
    var W = 44, H = 32, k = W / 780;
    var st = { id: 'icon', line: 'currentColor', lineWidth: 1.25 / k };
    return '<svg class="yxf-ficon" viewBox="-2 -2 ' + (W + 4) + ' ' + (H + 4) + '" aria-hidden="true">' +
      X().pitchSVG(formatId, st, { width: W, height: H }) + '</svg>';
  }

  // formation dot diagram: trapezoid outline, halfway line, one dot per slot
  function dotDiagram(formatId, formationId) {
    var P = X(), W = 34, H = 40;
    var G = P.pitchGeometry(formatId, { width: W, height: H }), c = G.corners;
    var fm = P.getFormation(formatId, formationId);
    var half = G.project(G.dims.width, G.dims.length / 2)[1];
    var hl = G.leftAt(half);
    var r = fm.slots.length > 9 ? 2.1 : fm.slots.length > 6 ? 2.4 : 2.7;
    var dots = fm.slots.map(function (s) {
      return '<circle cx="' + f1(s.x * W) + '" cy="' + f1(s.y * H - 2) + '" r="' + r + '"' + (s.role === 'GK' ? ' class="yxf-gk"' : '') + '/>';
    }).join('');
    return '<svg class="yxf-dots" viewBox="-2 -2 ' + (W + 4) + ' ' + (H + 4) + '" aria-hidden="true">' +
      '<path class="yxf-dline" d="M' + c.map(function (p) { return f1(p[0]) + ' ' + f1(p[1]); }).join(' L') + ' Z M' + f1(hl) + ' ' + f1(half) + ' L' + f1(W - hl) + ' ' + f1(half) + '"/>' +
      '<g class="yxf-dot">' + dots + '</g></svg>';
  }

  // style thumbnail: the real paper + pitch at print scale, with the current formation as dots
  function styleThumb(styleId, tint, formatId, formationId) {
    var P = X(), B = P.BOX, st = P.getStyle(styleId, tint);
    var slots = P.layoutSlots(formatId, formationId);
    var dots = slots.map(function (s) {
      return '<circle cx="' + f1(B.x + s.x) + '" cy="' + f1(B.y + s.y - 20) + '" r="' + f1(30 * s.s) + '" fill="' + st.textPrimary + '"/>';
    }).join('');
    return '<svg class="yxf-thumb" viewBox="0 0 900 1200" aria-hidden="true" preserveAspectRatio="xMidYMid slice">' +
      P.paperSVG(styleId, { width: 900, height: 1200, colour: tint }) +
      '<rect x="210" y="70" width="480" height="34" fill="' + st.textPrimary + '" opacity=".9"/>' +
      '<rect x="300" y="132" width="300" height="22" fill="' + st.textSecondary + '" opacity=".8"/>' +
      '<g transform="translate(' + B.x + ' ' + B.y + ')">' + P.pitchSVG(formatId, styleId, { colour: tint, lineWidth: (P.getStyle(styleId, tint).lineWidth || 6) * 2.2 }) + '</g>' +
      dots + '</svg>';
  }

  /* ---------- player remap ---------- */

  function remapPlayers(oldSlots, newSlots, players, opts) {
    opts = opts || {};
    oldSlots = oldSlots || []; newSlots = newSlots || []; players = players || [];
    var maxSubs = opts.maxSubs == null ? 5 : opts.maxSubs;
    var out = newSlots.map(function () { return null; });
    var taken = newSlots.map(function () { return false; });
    var todo = [];
    players.forEach(function (p, i) { if (p != null && oldSlots[i]) todo.push(i); });
    var placed = {};
    // normalise units so pixel and 0-1 slot lists can be compared
    var scale = function (list) {
      var m = 1; list.forEach(function (s) { m = Math.max(m, Math.abs(s.x), Math.abs(s.y)); });
      return m > 1.5 ? m : 1;
    };
    var ko = scale(oldSlots), kn = scale(newSlots);
    var dist = function (a, b) { var dx = a.x / ko - b.x / kn, dy = (a.y / ko - b.y / kn) * 0.8; return Math.sqrt(dx * dx + dy * dy); };
    var coarse = function (s) { return s.role || (s.fine === 'GK' ? 'GK' : ''); };

    function pass(test) {
      var pairs = [];
      todo.forEach(function (i) {
        if (placed[i]) return;
        newSlots.forEach(function (ns, j) { if (!taken[j] && test(oldSlots[i], ns)) pairs.push([dist(oldSlots[i], ns), i, j]); });
      });
      pairs.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
      pairs.forEach(function (p) {
        if (placed[p[1]] || taken[p[2]]) return;
        placed[p[1]] = true; taken[p[2]] = true; out[p[2]] = players[p[1]];
      });
    }
    var isGK = function (s) { return coarse(s) === 'GK' || s.fine === 'GK'; };
    pass(function (a, b) { return isGK(a) && isGK(b); });                                   // keeper stays keeper
    pass(function (a, b) { return !isGK(a) && !isGK(b) && a.fine && a.fine === b.fine; });    // same fine role
    pass(function (a, b) { return !isGK(a) && !isGK(b) && coarse(a) && coarse(a) === coarse(b); }); // same line
    pass(function (a, b) { return !isGK(a) && !isGK(b); });                                  // nearest outfield spot
    pass(function () { return true; });                                                       // last resort, even in goal

    var subs = (opts.subs || []).slice();
    var overflowSubs = subs.slice(maxSubs).filter(function (p) { return p != null; });
    subs = subs.slice(0, maxSubs);
    while (subs.length < maxSubs) subs.push(null);
    var moved = [], removed = [];
    todo.forEach(function (i) {
      if (placed[i]) return;
      var k = subs.indexOf(null);
      if (k >= 0) { subs[k] = players[i]; moved.push(players[i]); } else removed.push(players[i]);
    });
    removed = removed.concat(overflowSubs);
    var msg = [];
    if (moved.length) msg.push(moved.length + (moved.length > 1 ? ' players' : ' player') + ' moved to subs');
    if (removed.length) msg.push(removed.length + (removed.length > 1 ? ' players' : ' player') + " won't fit and will be removed");
    return { players: out, subs: subs, moved: moved, removed: removed, message: msg.join('. ') };
  }

  /* ---------- the picker ---------- */

  var uid = 0;
  function mount(el, opts) {
    if (!el) throw new Error('YXIFormats.mount needs a container element');
    opts = opts || {};
    var P = X(), id = 'yxf' + (++uid);
    var sel = { formatId: null, formationId: null, styleId: 'classic', tintColour: DEFAULT_TINT };
    var onChange = typeof opts.onChange === 'function' ? opts.onChange : function () {};

    function canon(next) {
      var F = P.getFormat(next.formatId);
      var fm = P.getFormation(F.id, next.formationId);
      var styleId = P.PITCH_STYLES[next.styleId] ? next.styleId : 'classic';
      return { formatId: F.id, formationId: fm.id, styleId: styleId, tintColour: normHex(next.tintColour) || DEFAULT_TINT };
    }
    sel = canon({ formatId: opts.formatId || 'eleven', formationId: opts.formationId, styleId: opts.styleId || 'classic', tintColour: opts.tintColour });

    el.classList.add('yxf');
    el.innerHTML =
      '<div class="yxf-field"><span class="yxf-label" id="' + id + 'f">Team format</span>' +
        '<div class="yxf-formats" role="radiogroup" aria-labelledby="' + id + 'f"></div></div>' +
      '<div class="yxf-field"><span class="yxf-label" id="' + id + 'm">Formation <span class="yxf-note"></span></span>' +
        '<div class="yxf-forms" role="radiogroup" aria-labelledby="' + id + 'm"></div></div>' +
      '<div class="yxf-field"><span class="yxf-label" id="' + id + 's">Pitch style</span>' +
        '<div class="yxf-styles" role="radiogroup" aria-labelledby="' + id + 's"></div>' +
        '<div class="yxf-tint" hidden><span class="yxf-sub" id="' + id + 't">Club colour</span>' +
          '<div class="yxf-tints" role="radiogroup" aria-labelledby="' + id + 't"></div></div></div>';

    var $f = el.querySelector('.yxf-formats'), $m = el.querySelector('.yxf-forms'), $s = el.querySelector('.yxf-styles');
    var $tw = el.querySelector('.yxf-tint'), $t = el.querySelector('.yxf-tints'), $note = el.querySelector('.yxf-note');

    $f.innerHTML = P.FORMATS.map(function (F) {
      return '<button type="button" class="yxf-fmt" role="radio" data-fmt="' + F.id + '" title="' + esc(F.label) + '">' +
        formatIcon(F.id) + '<span>' + esc(FORMAT_LABELS[F.id] || F.label) + '</span></button>';
    }).join('');

    $t.innerHTML = TINTS.map(function (t) {
      return '<button type="button" class="yxf-sw" role="radio" data-tint="' + t[0] + '" style="--c:' + t[0] + '" aria-label="' + t[1] + '" title="' + t[1] + '"></button>';
    }).join('') +
      '<label class="yxf-sw yxf-custom" title="Pick any colour"><input type="color" aria-label="Pick any colour"><span>Custom</span></label>';
    var $color = $t.querySelector('input[type=color]');

    function drawFormations(animate) {
      var F = P.getFormat(sel.formatId);
      $note.textContent = F.players + ' players, up to ' + F.maxSubs + ' subs';
      $m.innerHTML = F.formations.map(function (fm) {
        return '<button type="button" class="yxf-form" role="radio" data-fm="' + esc(fm.id) + '">' +
          dotDiagram(F.id, fm.id) + '<span>' + esc(fm.label) + '</span></button>';
      }).join('');
      if (animate) { $m.classList.remove('yxf-in'); void $m.offsetWidth; $m.classList.add('yxf-in'); }
      $m.scrollLeft = 0;
    }
    function drawStyles() {
      $s.innerHTML = STYLE_ORDER.map(function (sid) {
        var st = P.getStyle(sid, sel.tintColour);
        return '<button type="button" class="yxf-style" role="radio" data-st="' + sid + '">' +
          '<span class="yxf-tw">' + styleThumb(sid, sel.tintColour, sel.formatId, sel.formationId) + '</span>' +
          '<span>' + esc(st.label) + '</span></button>';
      }).join('');
    }
    function mark() {
      [].forEach.call($f.children, function (b) { var on = b.dataset.fmt === sel.formatId; b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1; });
      [].forEach.call($m.children, function (b) { var on = b.dataset.fm === sel.formationId; b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1; });
      [].forEach.call($s.children, function (b) { var on = b.dataset.st === sel.styleId; b.setAttribute('aria-checked', on); b.tabIndex = on ? 0 : -1; });
      var preset = false;
      [].forEach.call($t.querySelectorAll('[data-tint]'), function (b) { var on = b.dataset.tint === sel.tintColour; preset = preset || on; b.setAttribute('aria-checked', on); });
      var cust = $t.querySelector('.yxf-custom');
      cust.classList.toggle('yxf-on', !preset);
      cust.style.setProperty('--c', preset ? 'transparent' : sel.tintColour);
      $color.value = sel.tintColour.toLowerCase();
      $tw.hidden = sel.styleId !== 'clubTint';
      var on = $m.querySelector('[aria-checked="true"]');
      if (on && $m.scrollWidth > $m.clientWidth) {
        var l = on.offsetLeft - $m.offsetLeft, r = l + on.offsetWidth;
        if (l < $m.scrollLeft || r > $m.scrollLeft + $m.clientWidth) $m.scrollTo({ left: Math.max(0, l - 16), behavior: 'smooth' });
      }
    }
    function set(next, fire, animate) {
      var prev = sel, n = canon(Object.assign({}, sel, next));
      var fmtChanged = n.formatId !== prev.formatId;
      var thumbsChanged = fmtChanged || n.formationId !== prev.formationId || n.tintColour !== prev.tintColour;
      sel = n;
      if (fmtChanged) drawFormations(animate);
      if (thumbsChanged) drawStyles();
      mark();
      if (fire && (fmtChanged || thumbsChanged || n.styleId !== prev.styleId)) onChange(get(), prev);
    }
    function get() { return { formatId: sel.formatId, formationId: sel.formationId, styleId: sel.styleId, tintColour: sel.tintColour }; }

    function onClick(e) {
      var b = e.target.closest('button');
      if (!b || !el.contains(b)) return;
      if (b.dataset.fmt) {
        if (b.dataset.fmt === sel.formatId) return;
        var F = P.getFormat(b.dataset.fmt), keep = F.formations.some(function (f) { return f.id === sel.formationId; });
        set({ formatId: F.id, formationId: keep ? sel.formationId : F.defaultFormation }, true, true);
      } else if (b.dataset.fm) set({ formationId: b.dataset.fm }, true);
      else if (b.dataset.st) set({ styleId: b.dataset.st }, true);
      else if (b.dataset.tint) set({ tintColour: b.dataset.tint, styleId: 'clubTint' }, true);
    }
    // arrow keys move within a radiogroup
    function onKey(e) {
      var g = e.target.closest('[role=radiogroup]');
      if (!g || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
      var items = [].slice.call(g.querySelectorAll('button[role=radio]'));
      var i = items.indexOf(e.target.closest('button'));
      if (i < 0) return;
      e.preventDefault();
      var d = e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1;
      var nx = items[(i + d + items.length) % items.length];
      nx.click(); nx.focus();
    }
    var tintTimer;
    function onColour() {
      var v = normHex($color.value); if (!v) return;
      clearTimeout(tintTimer);
      tintTimer = setTimeout(function () { set({ tintColour: v, styleId: 'clubTint' }, true); }, 60);
    }
    el.addEventListener('click', onClick);
    el.addEventListener('keydown', onKey);
    $color.addEventListener('input', onColour);

    drawFormations(false); drawStyles(); mark();

    return {
      update: function (next) { set(next || {}, false, false); return get(); },
      get: get,
      destroy: function () {
        clearTimeout(tintTimer);
        el.removeEventListener('click', onClick);
        el.removeEventListener('keydown', onKey);
        $color.removeEventListener('input', onColour);
        el.innerHTML = ''; el.classList.remove('yxf');
      }
    };
  }

  var api = { mount: mount, remapPlayers: remapPlayers, TINTS: TINTS, FORMAT_LABELS: FORMAT_LABELS };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.YXIFormats = api;
})(this);
